<template>
    <div class="products_listing">
     <!-- <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>-->
        <CommonHead></CommonHead>
        <div class="container">
            <b-breadcrumb :items="breadcrumb"></b-breadcrumb>
            <div class="mainproduct_listing">
			<h1 class="desktop-hide">Samples</h1>
            <SKLoader
                :repeat="1"
                :loading="isFilterLoading"
                speed="1s"
                >
                <SKProductFilter/>
                </SKLoader>
                <div class="filterbar" v-if="isFilterLoading == false">
				<a @click="togglefilter" class="filtershow" href="#">Filter<b-img class="plusfil" src="/shop/images/add.svg" alt="add"></b-img><b-img class="minusfil" src="/shop/images/minus.svg" alt="minus"></b-img></a>
				<div class="allfilter">
                    <h6>QUICK SEARCH BY</h6>
                    <div class="filter_by">
                        <h6>Filter By</h6>
                        <ul>
                            <li><a href="javascript:;" v-b-toggle.collapse-brand>Types <b-img class="addicon" src="/shop/images/add.svg" fluid alt="add image"></b-img><b-img class="minusicon" src="/shop/images/minus.svg" fluid alt="minusimage"></b-img></a>
                            <b-collapse id="collapse-brand" accordion="my-accordion">
                                <ul>
                                    <li v-for="(lb,lbk) in loadTypes" :key="lbk"><md-checkbox :value="lb.NAME" v-model="form.types" @change="loadFilter(form)">{{lb.NAME}}</md-checkbox></li>
                                </ul>
                            </b-collapse>
                            </li>
                        </ul>
                    </div>
					<div class="mobile-category">
					<h4>Category</h4>
                    <ul>
                        <li><router-link to="/shop/products/fabric" :class="[selectedPage.includes('fabric') ? activeClass : '']">Fabrics</router-link></li>
                        <li><router-link to="/shop/products/trim" :class="[selectedPage.includes('trim') ? activeClass : '']">Trimming</router-link></li>
                        <!-- <li><router-link to="/shop/products/hardware" :class="[selectedPage.includes('hardware') ? activeClass : '']">Hardware</router-link></li> -->
                        <li><a href="/hardware-brands/">Hardware</a></li>
                        <li><router-link to="/shop/products/sample" :class="[selectedPage.includes('sample') ? activeClass : '']">Sample</router-link></li>
                    </ul>
					</div>
					</div>
                </div>
                <div class="productsbar">
                    <div class="topsection">
                        <h1 class="seo-purpose">Fabric Samples</h1>
                        <h2>Samples</h2>
                        <div class="sortby">
                            <label class="sort">Sort By: </label>
                            <v-select 
                                :options="sorting"
                                v-model="form.sort"
                                @input="loadFilter"
                                :reduce="sorting => sorting.value"
                                label="text"
                                :clearable="false"
                                :searchable="false"
                                placeholder="Sorting"
                            ></v-select>
                        </div>
                    </div>
                    <div class="productselectedfilter" v-if="(form.types.length > 0)">
                        <b-form-tags v-if="form.types.length > 0" v-model="form.types" no-outer-focus class="mb-2">
                            <template v-slot="{removeTag }">
                                <ul class="list-tag">
                                <b-card
                                    v-for="tag in form.types"
                                    :key="tag"
                                    :id="`tag_${tag.replace(/\s/g, '_')}_`"
                                    tag="li"
                                    class="mt-1 mr-1"
                                    body-class="py-1 pr-2 text-nowrap">
                                    <strong>{{ tag }}</strong>
                                    <b-button
                                    @click="removeTag(tag);refreshTag(tag)"
                                    variant="link"
                                    size="sm"
                                    :aria-controls="`tag_${tag.replace(/\s/g, '_')}_`"
                                    ><b-img class="closefilter" src="/shop/images/close.svg" fluid alt="close image"></b-img></b-button>
                                </b-card>
                                </ul>
                            </template>
                        </b-form-tags>
                        <a class="clearfilter" href="javascript:;" @click="resetFilter">Clear all</a>
                    </div>
                    <div class="mainproducts">
                        <SKLoader :repeat="4*3" :loading="isLoading">
                        <SKProductCard/>
                        </SKLoader>
                        <p v-if="rows == 0">No results found.</p>
                        <div class="productbox" v-for="(lp,lpk) in loadProducts" :key="lpk">
                            <a :href="'/shop/sample/'+lp.ITEMID" class="imgbox">
                                <b-img class="proimg" :src="lp.DETAIL[0].MEDIUM_IMAGE" fluid alt="product1 image"></b-img>
                            </a>
                            <div class="contentbox">
                                <div class="smallimages" v-if="lp.DETAIL.length > 0">
                                    <a v-for="(sw,swind) in lp.DETAIL" :key="swind" :href="'/shop/sample/'+lp.ITEMID" class="forborder">
                                        <b-img class="smallimg" :src="sw.SMALL_IMAGE" fluid alt="product1 image"></b-img>
                                    </a>
                                    <a :href="'/shop/sample/'+lp.ITEMID" class="forborder" v-if="lp.TOTALSWATCH > 5"><div class="moreprod">+{{lp.TOTALSWATCH - 5}}</div></a>
                                </div>
                                <h4><a :href="'/shop/sample/'+lp.ITEMID">{{lp.ITEMNAME}}</a></h4>
                                <p v-if="lp.DETAIL[0].PRICE">${{lp.DETAIL[0].PRICE}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="propagination" v-if="loadProducts.length>0">
                        <div class="mt-3 custompage">
                            <b-pagination
                                v-model="currentPage"
                                @input="paginationChange"
                                :total-rows="rows"
                                :per-page="perPage"
                                align="center"
                                first-number
                                last-number
                            ></b-pagination>
                        </div>
                        <div class="itemspage">
                            <label class="pageitem">Items per page :</label>
                            <v-select 
                                :options="itemspage"
                                v-model="form.items"
                                @input="loadFilter"
                                :clearable="false"
                                :searchable="false"
                                placeholder="40"
                            ></v-select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <CommonFoot></CommonFoot>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import CommonHead from "@/components/CommonHead";
import CommonFoot from "@/components/CommonFoot";
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import SKProductCard from "@/views/skeletons/SKProductCard";
import SKProductFilter from "@/views/skeletons/SKProductFilter";
export default {
  components: {
    CommonHead,
    CommonFoot,
    SKProductCard,
    SKProductFilter,
    'v-select': vSelect,
    Loading
  },
  metaInfo: {
    title: 'RM COCO | Order Samples',
    meta: [{
        name: 'description',
        content: 'Order RM COCO fabric samples, furniture samples, trim samples and hardware samples.'
    }],
  },
  computed:{
        selectedPage(){
            return this.$route.path;
        }
  },
  mounted(){
        this.isLoading = true;
        this.isFilterLoading = true;
        this.PageloadFilter();
  },
  data(){
      return{
        activeClass:'active',
        loadProducts:[],
        loadTypes:{},
        rows: 40,
        perPage: 40,
        currentPage: 1,
        sorting: [
          { value: 'abccode', text: 'A-Z'},
          { value: 'newest', text: 'Newest'},
          { value: 'lowtohigh', text: 'Price: Low to High'},
          { value: 'hightolow', text: 'Price: High to Low'}
        ],
        itemspage: [
           '20','40','100'
        ],
        quantity: 1,
        form:{
            types: [],
            items:40,
            sort:'abccode',
            page:1 
        },
        isLoading: false,
        isFilterLoading: true,
        breadcrumb: [
            {
                text: 'Home',
                href: '/'
            },
            {
                text: 'Sample',
                active: true
            }
        ]
      };
  },
  methods: {
		togglefilter(){
            $(".allfilter").toggle();
            $(".filtershow").toggleClass("minusshow");
		},
        paginationChange(page){
            this.form.page = page;
            this.loadFilter();
        },
        loadSampleFilters(){
            this.$store.dispatch("loadsamplefilters").then(loadsamplefilters => {
                this.loadTypes = loadsamplefilters.types;
            });
        },
		loadFilter(){
            this.isLoading = true;
            this.isFilterLoading = false;
            let url = [];
            if(this.form.types.length > 0){
                url["type"] = this.form.types.join();
            }
            if(this.form.items != null){
                url["items"] = this.form.items;
            }
            if(this.form.sort != null){
                url["sort"] = this.form.sort;
            }
            url["page"] = this.form.page;
            this.$router.push({query: url });
            
            var queryString = Object.keys(url).map((key) => {
                return encodeURIComponent(key) + '=' + encodeURIComponent(url[key])
            }).join('&');
            this.$store.dispatch("loadsampleProducts",queryString).then(loadProducts => {
                this.rows = loadProducts.data.total;
                this.currentPage = this.form.page;
                this.perPage = this.form.items;
                this.loadProducts = loadProducts.data.products;
                this.isLoading = false;
            });
			this.AciveFilter();
        },
		PageloadFilter(){
            let url = [];
            if(this.$route.query.type){
				url["type"] = this.$route.query.type;
				this.$root.$emit('bv::toggle::collapse', 'collapse-type');
			}
            if(this.$route.query.items){
                url["items"] = this.$route.query.items;
            }else{
                url["items"] = this.form.items;
            }
            if(this.$route.query.sort){
                url["sort"] = this.$route.query.sort;
            }else{
                url["sort"] = this.form.sort;
            }
            if(this.$route.query.page){
                url["page"] = this.$route.query.page;
                this.form.page = this.$route.query.page;
            }else{
                url["page"] = this.form.page;
            }
            
            this.$router.push({query: url });
            
            var queryString = Object.keys(url).map((key) => {
                return encodeURIComponent(key) + '=' + encodeURIComponent(url[key])
            }).join('&');
            this.loadSampleFilters();
            this.$store.dispatch("loadsampleProducts",queryString).then(loadProducts => {
                this.rows = loadProducts.data.total;
                this.currentPage = this.form.page;
                this.perPage = this.form.items;
                this.loadProducts = loadProducts.data.products;
                this.isLoading = false;
                this.isFilterLoading = false;
            });
			this.AciveFilter();
        },
		AciveFilter(){
            if(this.$route.query.type){
				this.form.types=this.$route.query.type.split(',');
			}
			if(this.$route.query.items){
			    this.form.items=this.$route.query.items;
			}
            if(this.$route.query.sort){
			    this.form.sort=this.$route.query.sort;
			}
        },
        refreshTag(tag){
            setTimeout(function () { this.loadFilter() }.bind(this), 500);
        },
        resetFilter(){
            this.form.types = [];
            this.form.items=40;
            this.form.sort='abccode';
            this.form.page=1; 
            this.loadFilter();
        }
    }
};
</script>
<style>

</style>